import TrackUtil from 'core/utils/TrackUtil';
import getLTV from './getLTV';

/**
 * Send "conversion" events to AdWords
 * @param {Object} order - (see below)
 * 		@param {Number} id - order ID
 * 		@param {Number} currencyCode
 * 		@param {Array} subscriptions - Array of subscription objects
 * 		@param {Number} total - order total (in cents)
 * 		@param {Number} totalWithServiceFee - order total (with service fee)
 */
export default function fireAdwordsConversions({
	id: orderId,
	currencyCode,
	subscriptions,
	total,
	totalWithServiceFee,
}) {
	total = totalWithServiceFee || total;
	const [ltv, termMultiplier] = getLTV({ subscriptions, total });

	if (window.goog_report_conversion) {
		window.goog_report_conversion(undefined, { currencyCode, ltv });
	}

	const p2 = TrackUtil.trackEvent("conversion", {
		gtag: [{
			// AdWords tag for checkout
			send_to: 'AW-957505549/crvICNiYjskBEI3AycgD',
			transaction_id: orderId,
			value: ltv / 100,
			currency: currencyCode,
		}, {
			// second adwords tag for "effective spend"
			send_to: 'AW-957505549/_cVyCMTS1OMBEI3AycgD',
			transaction_id: orderId,
			value: ltv / 100,
			currency: currencyCode,
		}],
	});

	const p1 = TrackUtil.trackEvent("google_conversion_data", {
		statjoy: [{
			subscription_id: subscriptions && subscriptions?.length > 0 && subscriptions[0].id,
			cus1: ltv,
			cus2: termMultiplier,
		}],
	});

	return Promise.allSettled([p1, p2]);
}
